(function () {
  "use strict";

  var DATA = window.PreTripStudyGuideData || { sections: [] };
  var STORAGE_KEY = "ptiqStudyGuideProgressV1";
  var state = loadState();

  function loadState() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || { completed: {}, quiz: {} };
    } catch (error) {
      return { completed: {}, quiz: {} };
    }
  }

  function saveState() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (error) {}
  }

  function esc(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function allComponents() {
    var items = [];
    DATA.sections.forEach(function (section) {
      section.components.forEach(function (component) {
        items.push({ section: section, component: component });
      });
    });
    return items;
  }

  function renderRoadmap() {
    var host = document.querySelector("[data-roadmap]");
    if (!host) return;

    host.innerHTML = DATA.sections.map(function (section) {
      return (
        '<a class="ptiq-guide-roadmap__item" href="#section-' + esc(section.id) + '">' +
          '<span>' + esc(section.number) + '</span>' +
          '<strong>' + esc(section.title) + '</strong>' +
          '<small>' + esc(section.subtitle) + '</small>' +
        '</a>'
      );
    }).join("");
  }

  function componentCard(section, item) {
    var completed = !!state.completed[item.id];
    var checks = item.check.map(function (check) {
      return "<li>" + esc(check) + "</li>";
    }).join("");

    var options = item.quiz.options.map(function (option, index) {
      return (
        '<button type="button" class="ptiq-guide-quiz__option" data-quiz-option="' +
        index + '">' + esc(option) + "</button>"
      );
    }).join("");

    return (
      '<article class="ptiq-guide-component ' + (completed ? "is-complete" : "") +
      '" id="component-' + esc(item.id) + '" data-component="' + esc(item.id) + '">' +
        '<button type="button" class="ptiq-guide-component__head" aria-expanded="false">' +
          '<span class="ptiq-guide-component__status" aria-hidden="true">' + (completed ? "✓" : "") + "</span>" +
          '<span class="ptiq-guide-component__title">' +
            '<small>' + esc(section.title) + (item.critical ? " • SAFETY-CRITICAL" : "") + "</small>" +
            '<strong>' + esc(item.name) + "</strong>" +
          "</span>" +
          '<span class="ptiq-guide-component__toggle" aria-hidden="true">+</span>' +
        "</button>" +

        '<div class="ptiq-guide-component__body" hidden>' +
          '<div class="ptiq-guide-iq-grid">' +
            iqBlock("KNOW IQ", item.know) +
            iqBlock("FIND IQ", item.find) +
            iqBlock("SAY IQ", item.say, "is-say") +
            '<section class="ptiq-guide-iq-card"><small>CHECK IQ</small><ul>' + checks + "</ul></section>" +
            iqBlock("WHY IQ", item.why) +
            iqBlock("FAILURE IQ", item.failure, "is-danger") +
            iqBlock("MEMORY IQ", item.memory, "is-memory") +
            iqBlock("COACH IQ", item.coach, "is-coach") +
          "</div>" +

          '<div class="ptiq-guide-quiz" data-quiz="' + esc(item.id) + '" data-answer="' + item.quiz.answer + '">' +
            '<div><small>QUICK TEST IQ</small><h4>' + esc(item.quiz.question) + "</h4></div>" +
            '<div class="ptiq-guide-quiz__options">' + options + "</div>" +
            '<p class="ptiq-guide-quiz__feedback" aria-live="polite"></p>' +
            '<script type="application/json" data-explanation>' + JSON.stringify(item.quiz.explanation) + "</script>" +
          "</div>" +

          '<div class="ptiq-guide-component__actions">' +
            '<button type="button" class="ptiq-guide-btn ptiq-guide-btn--complete" data-complete>' +
              (completed ? "Completed ✓" : "Mark Complete") +
            "</button>" +
            '<a class="ptiq-guide-btn ptiq-guide-btn--ghost" href="/pages/inspection-iq">Practice in Inspection IQ</a>' +
          "</div>" +
        "</div>" +
      "</article>"
    );
  }

  function iqBlock(label, text, extraClass) {
    return (
      '<section class="ptiq-guide-iq-card ' + (extraClass || "") + '">' +
        "<small>" + esc(label) + "</small>" +
        "<p>" + esc(text) + "</p>" +
      "</section>"
    );
  }

  function renderSections() {
    var host = document.querySelector("[data-guide-sections]");
    if (!host) return;

    host.innerHTML = DATA.sections.map(function (section) {
      return (
        '<section class="ptiq-guide-section" id="section-' + esc(section.id) + '">' +
          '<header class="ptiq-guide-section__head">' +
            '<span>' + esc(section.number) + "</span>" +
            "<div><small>INSPECTION AREA</small><h2>" + esc(section.title) + "</h2><p>" +
            esc(section.subtitle) + "</p></div>" +
          "</header>" +
          '<div class="ptiq-guide-section__memory"><small>MEMORY IQ</small><strong>' +
            esc(section.memory) + "</strong></div>" +
          '<div class="ptiq-guide-components">' +
            section.components.map(function (item) { return componentCard(section, item); }).join("") +
          "</div>" +
        "</section>"
      );
    }).join("");
  }

  function bindAccordions() {
    document.addEventListener("click", function (event) {
      var head = event.target.closest(".ptiq-guide-component__head");
      if (!head) return;

      var body = head.nextElementSibling;
      var expanded = head.getAttribute("aria-expanded") === "true";
      head.setAttribute("aria-expanded", String(!expanded));
      head.querySelector(".ptiq-guide-component__toggle").textContent = expanded ? "+" : "–";
      body.hidden = expanded;
    });
  }

  function bindCompletion() {
    document.addEventListener("click", function (event) {
      var button = event.target.closest("[data-complete]");
      if (!button) return;

      var card = button.closest("[data-component]");
      var id = card.getAttribute("data-component");
      state.completed[id] = !state.completed[id];
      card.classList.toggle("is-complete", state.completed[id]);
      card.querySelector(".ptiq-guide-component__status").textContent = state.completed[id] ? "✓" : "";
      button.textContent = state.completed[id] ? "Completed ✓" : "Mark Complete";
      saveState();
      updateProgress();
    });
  }

  function bindQuiz() {
    document.addEventListener("click", function (event) {
      var option = event.target.closest("[data-quiz-option]");
      if (!option) return;

      var quiz = option.closest("[data-quiz]");
      var chosen = Number(option.getAttribute("data-quiz-option"));
      var answer = Number(quiz.getAttribute("data-answer"));
      var feedback = quiz.querySelector(".ptiq-guide-quiz__feedback");
      var explanationNode = quiz.querySelector("[data-explanation]");
      var explanation = "";

      try { explanation = JSON.parse(explanationNode.textContent); } catch (error) {}

      quiz.querySelectorAll("[data-quiz-option]").forEach(function (button, index) {
        button.disabled = true;
        if (index === answer) button.classList.add("is-correct");
        if (index === chosen && chosen !== answer) button.classList.add("is-wrong");
      });

      feedback.textContent = (chosen === answer ? "Correct. " : "Not quite. ") + explanation;
      state.quiz[quiz.getAttribute("data-quiz")] = chosen === answer;
      saveState();
      updateProgress();
    });
  }

  function updateProgress() {
    var components = allComponents();
    var completeCount = components.filter(function (entry) {
      return !!state.completed[entry.component.id];
    }).length;
    var correctCount = Object.keys(state.quiz).filter(function (key) {
      return state.quiz[key] === true;
    }).length;
    var total = components.length;
    var percent = total ? Math.round((completeCount / total) * 100) : 0;

    document.querySelectorAll("[data-progress-percent]").forEach(function (node) {
      node.textContent = percent + "%";
    });
    document.querySelectorAll("[data-progress-fill]").forEach(function (node) {
      node.style.width = percent + "%";
    });
    document.querySelectorAll("[data-progress-copy]").forEach(function (node) {
      node.textContent = completeCount + " of " + total + " components completed • " +
        correctCount + " quick tests answered correctly";
    });
  }

  function bindSearch() {
    var input = document.querySelector("[data-guide-search]");
    var results = document.querySelector("[data-search-results]");
    if (!input || !results) return;

    input.addEventListener("input", function () {
      var query = input.value.trim().toLowerCase();
      if (query.length < 2) {
        results.innerHTML = "";
        results.hidden = true;
        return;
      }

      var matches = allComponents().filter(function (entry) {
        var haystack = [
          entry.section.title,
          entry.component.name,
          entry.component.know,
          entry.component.find,
          entry.component.check.join(" "),
          entry.component.why
        ].join(" ").toLowerCase();
        return haystack.indexOf(query) !== -1;
      }).slice(0, 8);

      results.innerHTML = matches.length ? matches.map(function (entry) {
        return (
          '<a href="#component-' + esc(entry.component.id) + '" data-search-link>' +
            "<small>" + esc(entry.section.title) + "</small>" +
            "<strong>" + esc(entry.component.name) + "</strong>" +
          "</a>"
        );
      }).join("") : '<p>No matching component found.</p>';
      results.hidden = false;
    });

    results.addEventListener("click", function (event) {
      var link = event.target.closest("[data-search-link]");
      if (!link) return;
      results.hidden = true;
      input.value = "";
      setTimeout(function () {
        var card = document.querySelector(link.getAttribute("href"));
        if (!card) return;
        var head = card.querySelector(".ptiq-guide-component__head");
        if (head.getAttribute("aria-expanded") !== "true") head.click();
      }, 50);
    });
  }

  function bindExpandAll() {
    var button = document.querySelector("[data-expand-all]");
    if (!button) return;

    var expanded = false;
    button.addEventListener("click", function () {
      expanded = !expanded;
      document.querySelectorAll(".ptiq-guide-component__head").forEach(function (head) {
        head.setAttribute("aria-expanded", String(expanded));
        head.querySelector(".ptiq-guide-component__toggle").textContent = expanded ? "–" : "+";
        head.nextElementSibling.hidden = !expanded;
      });
      button.textContent = expanded ? "Collapse All" : "Expand All";
    });
  }

  function mount() {
    renderRoadmap();
    renderSections();
    bindAccordions();
    bindCompletion();
    bindQuiz();
    bindSearch();
    bindExpandAll();
    updateProgress();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", mount);
  } else {
    mount();
  }
})();
